// src/components/Logo.jsx
import React from "react";
import logoSrc from "../TECH_DARK_BACKGROUND.png";

export default function Logo({ height = 40, style, alt = "Mana Tech Access" }) {
  return (
    <img
      src={logoSrc}
      alt={alt}
      style={{
        height,
        width: "auto",
        display: "block",
        objectFit: "contain",
        ...style,
      }}
    />
  );
}
